import { useEffect } from 'react'
import { Button } from '../../components/button'
import { Input } from '../../components/input'
import { Select } from '../../components/select'
import { useCompany } from '../../hooks/setup/useCompany'
import { useCompanyForm } from '../../hooks/setup/useCompanyForm'
import { useSteps } from '../../hooks/setup/useSteps'
import { usePhone } from '../../hooks/usePhone'
import { useTaxID } from '../../hooks/useTaxID'
import { CompanyType } from '../../utils/types'
import { SYSTEMS_OPTIONS } from './constants'
import './styles.scss'

export const Company = () => {
  const { nextStep } = useSteps()
  const {
    register: registerCompany,
    isLoading,
    getData: getDataCompany,
  } = useCompany()
  const { register, clearErrors, errors, handleSubmit, setValue } =
    useCompanyForm()
  const { formatCNPJ } = useTaxID()
  const { formatPhoneNumber } = usePhone()

  useEffect(() => {
    const loadData = async () => {
      const companyData = await getDataCompany()

      if (!companyData) return

      Object.entries(companyData).forEach(([key, value]) => {
        setValue(key as keyof CompanyType, value)
      })
    }

    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleCleanError = (type: keyof CompanyType) => clearErrors(type)

  const handlerRegisterCompany = async (data: CompanyType) => {
    registerCompany(data).then(async () => await nextStep())
  }

  return (
    <div className="container-company-root">
      <div className="content-title">
        <strong>Agora, os dados da sua empresa</strong>

        <p>
          Precisamos dessas informações para completar seu cadastro e selecionar
          as melhores funcionalidades para você.
        </p>
      </div>

      <div className="container-enter-data">
        <Input
          fullscreen
          placeholder="Nome da Empresa"
          error={errors.name?.message}
          {...register('name')}
          onChange={(event) => setValue('name', event.target.value)}
          onInput={() => handleCleanError('name')}
        />

        <Input
          placeholder="CNPJ"
          fullscreen
          error={errors.cnpj?.message}
          {...register('cnpj')}
          maxLength={18}
          onChange={(event) => setValue('cnpj', formatCNPJ(event.target.value))}
          onInput={() => handleCleanError('cnpj')}
        />

        <Input
          placeholder="Email"
          fullscreen
          type="email"
          error={errors.email?.message}
          {...register('email')}
          onChange={(event) => setValue('email', event.target.value)}
          onInput={() => handleCleanError('email')}
        />

        <Input
          placeholder="Celular"
          fullscreen
          error={errors.phone?.message}
          {...register('phone')}
          onChange={(event) =>
            setValue('phone', formatPhoneNumber(event.target.value))
          }
          onInput={() => handleCleanError('phone')}
        />

        <Select
          fullscreen
          error={errors.system?.message}
          optionsList={SYSTEMS_OPTIONS}
          defaultValue="Selecione o sistema de gerenciamento"
          {...register('system')}
          onChange={(event) => setValue('system', event.target.value)}
          onInput={() => handleCleanError('system')}
        />

        <div className="content-btn-submit">
          <Button
            onClick={handleSubmit(handlerRegisterCompany)}
            type="button"
            loading={isLoading}
            disabled={isLoading}
            className="content-btn-submit"
          >
            Avançar
          </Button>
        </div>
      </div>
    </div>
  )
}
